import { lazyLoadView } from '@utils/LazyLoad'
import { FEATURES } from '@constants/Text'

// ★ O meta é REPETIDO no filho de propósito. No vue-router 3, `route.meta` é o meta do
// registro MAIS PROFUNDO casado — não a fusão pai+filho —, e o guard global lê
// `routeTo.meta.can_show`/`.permission` (src/router/index.js). Como a rota-pai redireciona
// direto para `central-config.home`, um gate declarado só no pai NUNCA seria avaliado.
// Mesmo padrão de `power-bi/routes.js`, que repete `can_show` em `/bi` e em `bi.dash`.
const metaJornada = {
  can_show: FEATURES.CENTRAL_CONFIG,
  permission: ['profissional'],
}

export default [
  {
    path: '/central-config',
    name: 'central-config',
    // Gate reintroduzido em 2026-07-29, agora que o backend tem a funcionalidade
    // `Jornada de Configuração` em `FuncionalidadesNames` (aawz_base). Ele existiu, foi
    // removido em 2026-07-24 porque a flag não existia no backend e deixaria a rota 404
    // para todo mundo, e voltou quando essa condição deixou de valer. Sem a flag no
    // escritório, o guard responde `next({name:'404'})`.
    meta: metaJornada,
    redirect: { name: 'central-config.home' },
    component: () =>
      lazyLoadView(
        import(
          '@modules/central-config/views/nav-bar/central-config-nav-bar.vue'
        )
      ),
    children: [
      {
        path: '',
        name: 'central-config.home',
        meta: metaJornada,
        component: () =>
          lazyLoadView(
            import(
              '@modules/central-config/views/view-central-config-home.vue'
            )
          ),
      },
    ],
  },
]
